// P1 Business Health primary gauge + Executive Summary on the paid
// report page. Verbatim from PaidReport.jsx (W2c). Uses the `paid-report-*`
// test-id namespace (distinct from the Preview's `preview-*` namespace).
import BlackRockBand from "../BlackRockBand";

export default function ReportBusinessHealth({ businessHealth, executiveSummary }) {
  if (!businessHealth) return null;
  return (
    <div className="sf-card" style={{ marginBottom: 40 }} data-testid="paid-report-business-health-card">
      <BlackRockBand
        score={businessHealth.score}
        label={businessHealth.label}
        bandId={businessHealth.band}
        explanation={businessHealth.explanation}
        metricLabel="Business Health"
        size="primary"
        testId="paid-report-business-health"
      />
      <p className="sf-mono" style={{ fontSize: 11, color: "var(--sf-muted)", lineHeight: 1.6, marginTop: 12, letterSpacing: "0.02em" }} data-testid="paid-report-bh-methodology">
        Business Health is the weighted composite of five supporting systems: Revenue Recovery, Opportunity, Automation Readiness, Operations, and Retention.
      </p>
      {(executiveSummary || businessHealth.executive_summary) && (
        <div
          data-testid="paid-report-executive-summary"
          style={{
            marginTop: 26, paddingTop: 22,
            borderTop: "1px solid #22262B",
          }}
        >
          <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Executive Summary</div>
          <p style={{
            fontSize: 16, lineHeight: 1.6,
            color: "var(--sf-offwhite)", maxWidth: 760,
          }}>
            {executiveSummary || businessHealth.executive_summary}
          </p>
        </div>
      )}
    </div>
  );
}
